<template>
<div id="app" class="site container hfeed" style="height: auto !important">
  <HeadNav selectedLanguage="en" page="download" />

  <div id="page" class="site container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          <div class="entry-wrapper">
            <section class="download-content">
              <div class="download-header">
                <h1>Download Page of GB WhatsApp APK 2026</h1>
              </div>

              <div class="download-image-section">
                <img src="@/assets/home/home-1.webp" alt="GB WhatsApp APK Download" class="download-image">
              </div>

              <div class="app-info-section">
                <table class="app-info-table">
                  <tr>
                    <td class="info-label">App Name</td>
                    <td class="info-value">GB WhatsApp</td>
                  </tr>
                  <tr>
                    <td class="info-label">Version</td>
                    <td class="info-value">v18.70</td>
                  </tr>
                  <tr>
                    <td class="info-label">Size</td>
                    <td class="info-value">75.8MB</td>
                  </tr>
                  <tr>
                    <td class="info-label">System Support</td>
                    <td class="info-value">Android</td>
                  </tr>
                  <tr>
                    <td class="info-label">Last Updated</td>
                    <td class="info-value">1 Days Ago</td>
                  </tr>
                </table>
              </div>

              <div class="download-button-section">
                <button class="download-btn" @click="downloadfrom('main')">
                  <img src="@/assets/android.webp" alt="download icon">
                  Download GB WhatsApp APK
                </button>
              </div>

              <div class="download-guide">
                <h2>GB WhatsApp APK Download Guide For Android 2026</h2>
                <div class="guide-steps">
                  <div class="step">
                    <div class="step-number">Step 1</div>
                    <div class="step-content">Click the button Download GB WhatsApp APK.</div>
                  </div>
                  <div class="step">
                    <div class="step-number">Step 2</div>
                    <div class="step-content">Enable Install Unknown Source of your Android phone, then you can save the APK file.</div>
                  </div>
                  <div class="step">
                    <div class="step-number">Step 3</div>
                    <div class="step-content">Follow the on screen guide to install GBWhatsApp 2026. You can give permission to finish the installation.</div>
                  </div>
                  <div class="step">
                    <div class="step-number">Step 4</div>
                    <div class="step-content">Launch GB WhatsApp app and verify account.</div>
                  </div>
                </div>
              </div>

          
            </section>
          </div>
        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Download',
  data() {
    return {
      pageName: 'download',
      showapk: false,

      apk: process.env.VUE_APP_GBLINK,
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
    };
  },
  components: {
    HeadNav,
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhataps.com&appName=GB_gbwhataps.com`;
    },
    gotoblog() {
      window.location.href = '/blogs';
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200 && res.data && res.data.apk) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhataps.com',
          appName: appname || 'GB_gbwhataps.com',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1 && res.data && res.data.apk) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    download() {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    goto(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
    // download() {
    // 	console.log(this.apk);
    // 	this.$global.download(this.apk);
    // },
  },
};
</script>

<style lang="scss" scoped>
.download-content {
  // max-width: 800px;
  margin: 1rem auto;
  padding: 40px 20px;
  background: #fff;
  border-radius: 12px;
  // box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.download-header {
  text-align: center;
  margin-bottom: 40px;
}

.download-header h1 {
  color: #25D366;
  font-size: 2.5em;
  font-weight: 700;
  margin-bottom: 30px;
  line-height: 1.2;
}

.download-image {
  width: 100%;
  max-width: 200px;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.app-info-section {
  margin: 40px 0;
}

.app-info-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.app-info-table tr {
  border-bottom: 1px solid #eee;
}

.app-info-table tr:last-child {
  border-bottom: none;
}

.app-info-table tr:nth-child(even) {
  background-color: #f8f9fa;
}

.info-label {
  font-weight: 600;
  color: #128C7E;
  font-size: 14px;
  padding: 15px 20px;
  width: 30%;
  background-color: #f0f8f5;
  border-right: 1px solid #ddd;
}

.info-value {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  padding: 15px 20px;
}

.download-button-section {
  text-align: center;
  margin: 40px 0;
}

.download-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  color: white;
  border: none;
  padding: 18px 32px;
  border-radius: 50px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(37, 211, 102, 0.3);
}

.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(37, 211, 102, 0.4);
  background: linear-gradient(135deg, #128C7E 0%, #075E54 100%);
}

.download-btn img {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

.app-info-section {
  margin: 40px 0;
}

.app-info-section h2 {
  color: #25D366;
  font-size: 1.8em;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: left;
}

.app-info-table {
  background: #f8f9fa;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.app-info-table table {
  width: 100%;
  border-collapse: collapse;
}

.app-info-table th,
.app-info-table td {
  padding: 16px 20px;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}

.app-info-table th {
  background: #e9f7ef;
  color: #128C7E;
  font-weight: 600;
  width: 40%;
}

.app-info-table tr:last-child td,
.app-info-table tr:last-child th {
  border-bottom: none;
}

.download-instructions {
  margin: 40px 0;
}

.download-instructions h2 {
  color: #25D366;
  font-size: 1.8em;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: left;
}

.download-instructions ol {
  background: #f8f9fa;
  padding: 30px 40px;
  border-radius: 12px;
  border-left: 4px solid #25D366;
}

.download-instructions li {
  margin-bottom: 15px;
  line-height: 1.6;
  font-size: 16px;
}

.download-instructions li:last-child {
  margin-bottom: 0;
}

.download-guide {
  margin: 40px 0;
}

.download-guide h2 {
  color: #25D366;
  font-size: 1.8em;
  font-weight: 700;
  margin-bottom: 30px;
  text-align: center;
}

.guide-steps {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.step {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 25px;
  background: #f8f9fa;
  border-radius: 12px;
  border-left: 4px solid #25D366;
  transition: all 0.3s ease;
  text-align: left;
}

.step:hover {
  background: #e9f7ef;
  transform: translateX(5px);
}

.step-number {
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  color: white;
  font-weight: 700;
  font-size: 16px;
  padding: 12px 20px;
  border-radius: 50px;
  min-width: 80px;
  text-align: center;
  flex-shrink: 0;
}

.step-content {
  font-size: 16px;
  line-height: 1.6;
  color: #444;
  flex: 1;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .download-content {
    padding: 20px 15px;
  }
  
  .download-header h1 {
    font-size: 2em;
  }
  
  .download-btn {
    padding: 15px 25px;
    font-size: 16px;
  }
  
  .download-btn img {
    width: 20px;
    height: 20px;
  }
  
  .app-info-table th,
  .app-info-table td {
    padding: 12px 15px;
    font-size: 14px;
  }
  
  .download-instructions ol {
    padding: 20px 25px;
  }
  
  .download-instructions li {
    font-size: 14px;
  }
  
  .app-info-table {
    font-size: 14px;
  }
  
  .info-label {
    font-size: 12px;
    padding: 12px 15px;
    width: 35%;
  }
  
  .info-value {
    font-size: 14px;
    padding: 12px 15px;
  }
  
  .download-guide h2 {
    font-size: 1.5em;
  }
  
  .step {
    flex-direction: column;
    gap: 15px;
    padding: 20px;
    text-align: left;
  }
  
  .step-number {
    align-self: flex-start;
    min-width: 60px;
    padding: 10px 15px;
    font-size: 14px;
  }
  
  .step-content {
    font-size: 14px;
  }
}
</style>
